module.exports = __webpack_public_path__ + "img/scan-icon.e5720252.svg";